
import { HttpProvider } from "../http/http.provider";
import { IAppConfig } from "../http/types/IApplicationConfig";

import { addProvider, IProviderDescriptor, ServiceEndpointConstants } from "../ServiceUtil";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";
import { IHttpRequestConfig } from "../http";
import { INewResourceBulk, 
INewResourceDocument, 
IResource, 
IResourceResponse,
 IResourceWorkExperience } from "./resource.interface";
import { createFormData } from "../util/utilities";


export class ResourceDelegate
{
 
    constructor(private SERVICE_CONFIG: IAppConfig, private http: HttpProvider)
    {
    }


    public getResourceDetailById(resourceId: string): Observable<IResourceResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                resourceUniqueId: resourceId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.RESOURCE.GET_BY_ID, null, config).pipe(
            map((response: any) =>
            {
                return {
                    resource: response.data.resource,
                    success: response.data.success
                };
            }),
            share());
    }

    public getAllResources(orgId: string): Observable<IResourceResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                orgId: orgId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.RESOURCE.GET, null, config).pipe(
            map((response: any) =>
            {
                return {
                    resources: ResourceDelegate.normalizeResources(response.data.resources || []),
                    success: response.data.success
                };
            }),
            share());
    }

    public createNewResourceExperience(newResource: IResourceWorkExperience): Observable<IResourceResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.RESOURCE.CREATE_EXPEREINCE, newResource).pipe(
            map((response: any) =>
            {
                return {
                    resource: response.data.resource,
                    success: response.data.success,
                    resourceId: response.data.resourceId
                };
            }),
            share());
    }

    public updateResourceExperience(newResource: IResourceWorkExperience): Observable<IResourceResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.RESOURCE.UPDATE_EXPERIENCE, newResource).pipe(
            map((response: any) =>
            {
                return {
                    resource: response.data.resource,
                    success: response.data.success,
                    resourceId: response.data.resourceId
                };
            }),
            share());
    }

    public createNewresource(newResource: IResource): Observable<IResourceResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.RESOURCE.CREATE, newResource).pipe(
            map((response: any) =>
            {
                return {
                    resources: ResourceDelegate.normalizeResources(response.data.resources || []),
                    success: response.data.success,
                    resourceId: response.data.resourceId
                };
            }),
            share());
    }
    public createNewResourceBulk(newBenchLead: INewResourceBulk): Observable<IResourceResponse>
    {
        const formdata = createFormData(newBenchLead);

        return this.http.post(ServiceEndpointConstants.endpoints.RESOURCE.CREATE_BULK, formdata).pipe(
            map((response: any) =>
            {
                return {
                    resources: ResourceDelegate.normalizeResources(response.data.resources || []),
                    resourceId: response.data.resourceId,
                    message: response.data.message,
                    success: response.data.success
                };
            }),
            share());
    }


    public createResourceDocuments(documents: INewResourceDocument): Observable<IResourceResponse>
    {
        const formdata = createFormData(documents);

        return this.http.post(ServiceEndpointConstants.endpoints.RESOURCE.CREATE_DOCUMENT, formdata).pipe(
            map((response: any) =>
            {
                return {
                    resource: response.data.resource,
                    resourceId: response.data.resourceId,
                    success: response.data.success
                };
            }),
            share());
    }

    public updateResource(resource: IResource): Observable<IResourceResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.RESOURCE.UPDATE, resource).pipe(
            map((response: any) =>
            {
                return {
                    resources: ResourceDelegate.normalizeResources(response.data.resources || []),
                    success: response.data.success,
                    resourceId: resource.resourceId
                };
            }),
            share());
    }

    public static normalizeResources(resources: any): IResource[]
    {
        return resources.map(resource =>
        { 
            
            return resource;
        });
    }
}